var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 418 413.5",
    style: {
      enableBackground: "new 0 0 418 413.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M404.8,328.4l-76.6-76.6c-10.2-10.2-26.2-11.7-38.1-3.6l-48.9,33.4c-4,2.7-9.3,2.2-12.7-1.2l-95.3-95.3 c-3.4-3.4-3.9-8.7-1.2-12.7l33.4-48.9c8.1-11.9,6.6-28-3.6-38.1L85.1,8.8C73.4-2.9,54.4-2.9,42.7,8.8 c-56.9,56.9-56.9,149.6,0,206.5l64.4,64.4c3.9,3.9,10.2,3.9,14.1,0c3.9-3.9,3.9-10.2,0-14.1l-64.4-64.4 C33,177.3,19.9,145.7,19.9,112S33,46.7,56.8,22.9c1.9-1.9,4.4-2.9,7.1-2.9c2.7,0,5.2,1,7.1,2.9l76.6,76.6 c3.4,3.4,3.9,8.7,1.2,12.7L133.9,134L76.7,76.7c-3.9-3.9-10.2-3.9-14.1,0c-3.9,3.9-3.9,10.2,0,14.1l59.9,59.9l-7.1,10.3 c-8.1,11.9-6.6,28,3.6,38.1l95.3,95.3c10.2,10.2,26.2,11.7,38.1,3.6l48.9-33.4c4-2.7,9.3-2.2,12.7,1.2l76.6,76.6 c1.9,1.9,2.9,4.4,2.9,7.1c0,2.7-1,5.2-2.9,7.1c-5.8,5.8-12,10.9-18.6,15.4l-59.7-59.7c-3.9-3.9-10.2-3.9-14.1,0 c-3.9,3.9-3.9,10.2,0,14.1l55.8,55.8c-16.2,7.4-34,11.3-52.4,11.3c-33.7,0-65.3-13.1-89.1-36.9L170.8,315 c-3.9-3.9-10.2-3.9-14.1,0c-3.9,3.9-3.9,10.2,0,14.1l41.7,41.7c28.5,28.5,65.9,42.7,103.2,42.7s74.8-14.2,103.2-42.7 C416.5,359.2,416.5,340.1,404.8,328.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146.3,290.6c-1.9-1.9-4.4-2.9-7.1-2.9c-2.6,0-5.2,1.1-7.1,2.9c-1.9,1.9-2.9,4.5-2.9,7.1s1.1,5.2,2.9,7.1s4.4,2.9,7.1,2.9 c2.6,0,5.2-1.1,7.1-2.9c1.9-1.9,2.9-4.4,2.9-7.1S148.1,292.4,146.3,290.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.930218cdaa68fe8dee6d48fa428fb37c.svg";
export { ForwardRef as ReactComponent };